import { Grid } from "@mui/material";
import { Apply } from "./apply/Apply";
import { PkCommonFooter } from "../../components/common/PkCommonFooter";
import { PkCommonHeader } from "../../components/common/PkCommonHeader";
export function DeveloperPage() {
  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid xs={12} item>
        <PkCommonHeader/>
      </Grid>
      <Grid xs={12} item>
        <Apply />
      </Grid>
      <Grid xs={12} item>
        <PkCommonFooter />
      </Grid>
    </Grid>
  );
}
